import { Chip } from '@mui/material';
import type React from 'react';
import type { CampaignStatus } from '../types';

const statusColor = (status: CampaignStatus) => {
  if (status === 'SENT') return 'success';
  if (status === 'SENDING') return 'info';
  if (status === 'FAILED' || status === 'PARTIALLY_FAILED') return 'error';
  if (status === 'CANCELLED' || status === 'RETRACTED') return 'warning';
  return 'default';
};

export const CampaignStatusBadge: React.FC<{ status: CampaignStatus }> = ({ status }) => (
  <Chip label={status} size="small" color={statusColor(status)} />
);
